<template>
  <div class="modal fade custom-modal verify-modal" id="aws-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>AWS Settings</h4>
          <div class="aws-setting">
            <div class="active-switch aws-act-set">
              <label class="switch">
                <input type="checkbox" checked />
                <span class="sliders round"></span>
              </label>
            </div>
            <span>
              <a href="">
                <i class="feather-x"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>AWS Access Key <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Secret Key <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Bucket Name <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Region <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Base URL <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <a href="" class="btn btn-primary">Submit</a>
          <a href="" class="btn btn-secondary">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</template>
